import React, { useState, useEffect } from "react";
// import { Modal } from "antd";
import { Modal, CircularProgress, Typography, Slider } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarker,
  faArrowUpFromWaterPump,
} from "@fortawesome/free-solid-svg-icons";
import Table from "@mui/material/Table";
import html2canvas from "html2canvas";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { FaArrowUp } from "react-icons/fa";
import { FaArrowDown } from "react-icons/fa";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableSortLabel from "@mui/material/TableSortLabel";
import { Button, TextField } from "@mui/material";
import {
  ResponsiveContainer,
  LineChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Line,
  Brush,
} from "recharts";

import "./leftbar.css";

import { format, set } from "date-fns";

import mapmarkericon from "./assets/images/mapmarker.png";
import warpo from "./warpo.png";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { saveAs } from "file-saver";
import Papa from "papaparse";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import Datalog from "./datalog";
import Imputlog from "./dataImputLog";
import MultiColImputeLog from "./multiColImputeLog";
import MultiColAnomalyLog from "./multiColAnomalyLog";
import MultiColForecastLog from "./multiColForecastLog";
import Anomalylog from "./AnomalyLog";
import Forecastlog from "./dataForecastLog";
import Purifiedlog from "./purifiedDatalog";
const HelpModal = ({ open, handleClose }) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <div className="help-modal-container">
        <div className="help-modal-close">
          <Button variant="contained" color="secondary" onClick={handleClose}>
            Close
          </Button>
        </div>
        <Typography variant="h5">📌 Zoom and Hover Guide</Typography>

        <Typography variant="h6">🔍 Zoom Controls</Typography>
        <ul>
          <li>
            <strong>Zoom In:</strong> Click <em>Zoom In</em> to magnify the
            chart.
          </li>
          <li>
            <strong>Zoom Out:</strong> Click <em>Zoom Out</em> to view more data
            points.
          </li>
          <li>
            <strong>Reset Zoom:</strong> Click <em>Reset Zoom</em> to restore
            the default view.
          </li>
          <li>
            <strong>Slider Control:</strong> Drag the slider to adjust the zoom
            level manually.
          </li>
          <li>
            <strong>Brush Zoom:</strong> Drag over the X-axis to select a custom
            time range.
          </li>
        </ul>

        <Typography variant="h6">🖱️ Hover Feature</Typography>
        <ul>
          <li>
            <strong>Tooltip:</strong> Hover over data points to see detailed
            values.
          </li>
          <li>
            <strong>Interactive Dots:</strong> Data points expand and highlight
            on hover.
          </li>
        </ul>

        <Typography variant="h6">🎮 User Actions</Typography>
        <ul>
          <li>
            <strong>Click "Zoom In":</strong> Focuses on a specific range of
            data.
          </li>
          <li>
            <strong>Click "Zoom Out":</strong> Expands the view.
          </li>
          <li>
            <strong>Drag the Slider:</strong> Adjusts the zoom level.
          </li>
          <li>
            <strong>Click "Reset Zoom":</strong> Resets the graph to full view.
          </li>
          <li>
            <strong>Hover Over Data Points:</strong> Displays tooltips with
            precise values.
          </li>
          <li>
            <strong>Drag Over the Brush Area Under The Chart:</strong> Allows
            custom zoom selection.
          </li>
        </ul>

        {/* Close Button */}
      </div>
    </Modal>
  );
};

const Leftbar = ({
  selectedMarker,
  setSelectedMarker,
  datalogs,
  setDatalogs,
  firstImdatalogs,
  firstMultiColImDatalogs,
  showRegionInfo,
  setShowRegionInfo,
  isregionClicked,
  getStrokeColor,
  regions,
  handleClearLeftbar,
  selectedColor,
  setSelectedColor,
  getWellMarkerCount,
  regionClicked,
  setRegionClicked,
  getWellMarkersInRegion,
}) => {
  const [imageZoomed, setImageZoomed] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isImModalOpen, setIsImModalOpen] = useState(false);
  const [IsMultiColImModalOpen, setIsMultiColImModalOpen] = useState(false);
  const [isFcModalOpen, setIsFcModalOpen] = useState(false);
  const [isMultiColFcModalOpen, setIsMultiColFcModalOpen] = useState(false)
  const [isAnModalOpen, setIsAnModalOpen] = useState(false);
  const [IsMultiColAnModalOpen, setIsMultiColAnModalOpen] = useState(false);
  const [imdatalogs, setimDatalogs] = useState(firstImdatalogs);
  const [multiColImDatalogs, setMultiColImDatalogs] = useState(firstMultiColImDatalogs);
  const [isHovering, setIsHovering] = useState(false);
  const [purifiedDatalogs, setPurifiedDatalogs] = useState(datalogs);
  const [ispurifiedModalOpen,setispurifiedModalOpen] = useState(false);
  
  // const [startIndex, setStartIndex] = useState(0);
  // const [endIndex, setEndIndex] = useState(datalogs.length - 1);
  const [helpOpen, setHelpOpen] = useState(false);
  // const [zoomLevel, setZoomLevel] = useState(0); // Default zoom is 0%
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString(); // Modify format as needed
  };
  const [zoomLevelDatalogs, setZoomLevelDatalogs] = useState(0);
  const [startIndexDatalogs, setStartIndexDatalogs] = useState(0);
  const [endIndexDatalogs, setEndIndexDatalogs] = useState(datalogs.length - 1);

  const [zoomLevelImDatalogs, setZoomLevelImDatalogs] = useState(0);
  const [startIndexImDatalogs, setStartIndexImDatalogs] = useState(0);
  const [endIndexImDatalogs, setEndIndexImDatalogs] = useState(
    imdatalogs.length - 1
  );
const [role, setRole] = useState(0);
const getRole = () => {
  const role= localStorage.getItem("role");
  setRole(role);
  console.log(role);
  return role;
};
  useEffect(() => {
    getRole();
  }, []);
  // const handleZoom = (event, newValue) => {
  //   setZoomLevel(newValue);
  //   const range = datalogs.length;
  //   const zoomFactor = newValue / 100; // Convert zoom percentage to factor

  //   const newStart = Math.floor(range * zoomFactor * 0.5); // Adjust start index
  //   const newEnd = Math.ceil(range * (1 - zoomFactor * 0.5)); // Adjust end index

  //   setStartIndex(newStart >= 0 ? newStart : 0);
  //   setEndIndex(newEnd <= datalogs.length - 1 ? newEnd : datalogs.length - 1);
  // };

  // Handle zoom for general datalogs
  // const handleZoomDatalogs = (event, newValue) => {
  //   setZoomLevelDatalogs(newValue);
  //   const range = datalogs.length;
  //   const zoomFactor = newValue / 100;

  //   const newStart = Math.floor(range * zoomFactor * 0.5);
  //   const newEnd = Math.ceil(range * (1 - zoomFactor * 0.5));

  //   setStartIndexDatalogs(newStart >= 0 ? newStart : 0);
  //   setEndIndexDatalogs(
  //     newEnd <= datalogs.length - 1 ? newEnd : datalogs.length - 1
  //   );
  // };
  useEffect(() => {
    setStartIndexImDatalogs(0);
    setEndIndexImDatalogs(imdatalogs.length - 1);
  }, [imdatalogs]); // Ensures indices update when new data comes in

  // // Handle zoom for imputed datalogs
  // const handleZoomImDatalogs = (event, newValue) => {
  //   setZoomLevelImDatalogs(newValue);
  //   const range = imdatalogs.length;
  //   const zoomFactor = newValue / 100;

  //   const newStart = Math.floor(range * zoomFactor * 0.5);
  //   const newEnd = Math.ceil(range * (1 - zoomFactor * 0.5));

  //   setStartIndexImDatalogs(newStart >= 0 ? newStart : 0);
  //   setEndIndexImDatalogs(newEnd <= imdatalogs.length - 1 ? newEnd : imdatalogs.length - 1);
  // };

  const handleClosepurifiedModal = () => {
    setispurifiedModalOpen(false);
  };
  const handleShowPurifiedDatalog = () => {

    setispurifiedModalOpen(true);
    setPurifiedDatalogs(datalogs);
    resetZoomDatalogs();
  };
  const handleZoomImDatalogs = (event, newValue) => {
    setZoomLevelImDatalogs(newValue);
    const range = imdatalogs.length;
    const zoomFactor = newValue / 100;

    const newStart = Math.floor(range * zoomFactor * 0.5);
    const newEnd = Math.ceil(range * (1 - zoomFactor * 0.5));

    setStartIndexImDatalogs(Math.max(0, newStart));
    setEndIndexImDatalogs(Math.min(imdatalogs.length - 1, newEnd));
  };

  // Zoom In/Out & Reset for General Datalogs
  const handleZoomInDatalogs = () =>
    setZoomLevelDatalogs((prev) => Math.min(prev + 10, 100));
  const handleZoomOutDatalogs = () =>
    setZoomLevelDatalogs((prev) => Math.max(prev - 10, 0));
  const resetZoomDatalogs = () => {
    setStartIndexDatalogs(0);
    setZoomLevelDatalogs(0);
    setEndIndexDatalogs(datalogs.length - 1);
  };

  // const handleZoomIn = () => {
  //   setZoomLevel((prevZoom) => Math.min(prevZoom + 10, 100)); // Increase zoom level up to 100%

  //   setStartIndex((prevStart) => {
  //     const range = endIndex - prevStart;
  //     const zoomFactor = zoomLevel / 100;
  //     const newStart = Math.min(
  //       prevStart + Math.ceil(range * zoomFactor * 0.1),
  //       endIndex - 2
  //     );
  //     return newStart >= 0 ? newStart : 0;
  //   });

  //   setEndIndex((prevEnd) => {
  //     const range = prevEnd - startIndex;
  //     const zoomFactor = zoomLevel / 100;
  //     const newEnd = Math.max(
  //       prevEnd - Math.ceil(range * zoomFactor * 0.1),
  //       startIndex + 2
  //     );
  //     return newEnd <= datalogs.length - 1 ? newEnd : datalogs.length - 1;
  //   });
  // };

  // const handleZoomOut = () => {
  //   setZoomLevel((prevZoom) => Math.max(prevZoom - 10, 0)); // Decrease zoom level to minimum 0%

  //   setStartIndex((prevStart) => {
  //     const range = endIndex - prevStart;
  //     const zoomFactor = zoomLevel / 100;
  //     return Math.max(prevStart - Math.ceil(range * zoomFactor * 0.1), 0);
  //   });

  //   setEndIndex((prevEnd) => {
  //     const range = prevEnd - startIndex;
  //     const zoomFactor = zoomLevel / 100;
  //     return Math.min(
  //       prevEnd + Math.ceil(range * zoomFactor * 0.1),
  //       datalogs.length - 1
  //     );
  //   });
  // };

  // Zoom In/Out & Reset for Imputed Datalogs
  const handleZoomInImDatalogs = () =>
    setZoomLevelImDatalogs((prev) => Math.min(prev + 10, 100));
  const handleZoomOutImDatalogs = () =>
    setZoomLevelImDatalogs((prev) => Math.max(prev - 10, 0));
  const resetZoomImDatalogs = () => {
    setStartIndexImDatalogs(0);
    setZoomLevelImDatalogs(0);
    setEndIndexImDatalogs(imdatalogs.length - 1);
  };
  // const resetZoom = () => {
  //   setStartIndex(0);
  //   setZoomLevel(0);
  //   setEndIndex(datalogs.length - 1);
  // };

  // const visibleData = datalogs.slice(startIndex, endIndex + 1);

  // Visible Data Calculation
  const visibleDataDatalogs = datalogs.slice(
    startIndexDatalogs,
    endIndexDatalogs + 1
  );
  const visibleDataImDatalogs = imdatalogs.slice(
    startIndexImDatalogs,
    endIndexImDatalogs + 1
  );

  const [selectedMetric, setSelectedMetric] = useState("wtr"); // Default to Water Level

  const [dataLimitDatalogs, setDataLimitDatalogs] = useState(
    visibleDataDatalogs.length
  ); // Default to all data
  const [dataLimitImDatalogs, setDataLimitImDatalogs] = useState(
    visibleDataImDatalogs.length
  ); // Default to all data

  const handleMetricChange = (event) => {
    setSelectedMetric(event.target.value);
  };

  const handleDataLimitChangeDatalogs = (event) => {
    setDataLimitDatalogs(parseInt(event.target.value));
  };

  // Apply the data limit to the visible data
  const filteredDataDatalogs = visibleDataDatalogs.slice(-dataLimitDatalogs); // Show the last N data points

  const handleDataLimitChangeImDatalogs = (event) => {
    setDataLimitImDatalogs(parseInt(event.target.value));
  };

  // Apply the data limit to the visible data
  const filteredDataImDatalogs = visibleDataImDatalogs.slice(
    -dataLimitImDatalogs
  );
  // const filteredDataImDatalogs = visibleDataImDatalogs.slice(-dataLimitImDatalogs); // Show the last N data points

  const CustomLegend = () => {
    return (
      <div className="custom-legend">
        <p>
          <strong>Well ID:</strong> {selectedMarker.wellId}
        </p>
        <p>
          <strong>Location:</strong> {selectedMarker.union_} ,
          {selectedMarker.upazilla}, {selectedMarker.district},{" "}
          {selectedMarker.division}
        </p>
      </div>
    );
  };

  const [sortConfig, setSortConfig] = useState({
    mTm: { direction: "asc" },
    wtr: { direction: "asc" },
    // tmp: { direction: "asc" },
    // prs: { direction: "asc" },
  });
  const formatXAxis = (tickItem) => {
    return format(new Date(tickItem), "yyyy-MM-dd HH:mm:ss");
  };
  // State for model weights
  const [weights, setWeights] = useState({
    weight_lstm: 0,
    weight_bilstm: 0,
    weight_arima: 0,
    weight_sarima: 0,
    weight_iter: 0,
  });
  // Custom Dot Component
  const CustomDot = (props) => {
    const { cx, cy, payload } = props;
    if (payload.is_imputed === 1) {
      return (
        <circle cx={cx} cy={cy} r={5} stroke="red" strokeWidth={2} fill="red" />
      );
    }

    return (
      <circle
        cx={cx}
        cy={cy}
        r={5}
        stroke="black"
        strokeWidth={2}
        fill="blue"
      />
    );
  };

  // Custom Dot Component
  const CustomDotAnomaly = (props) => {
    const { cx, cy, payload } = props;
    if (payload.is_anomaly_corrected === 1) {
      return (
        <circle
          cx={cx}
          cy={cy}
          r={5}
          stroke="orange"
          strokeWidth={2}
          fill="orange"
        />
      );
    }

    return (
      <circle
        cx={cx}
        cy={cy}
        r={5}
        stroke="black"
        strokeWidth={2}
        fill="blue"
      />
    );
  };

  const handleWeightChange = (event) => {
    const { name, value } = event.target;
    if (isNaN(value)) {
      alert("Please enter a numerical value");
      return;
    }
    setWeights((prevWeights) => ({
      ...prevWeights,
      [name]: value,
    }));
  };

  const [progress, setProgress] = useState(0);

  const [Rate, setRate] = useState("");
  const handleRateChange = (event) => {
    setRate(event.target.value);
  };

  const [AnRate, setAnRate] = useState("");
  const handleAnRateChange = (event) => {
    setAnRate(event.target.value);
  };

  const [option, setOption] = useState("overall"); // Initialize with the string "overall"

  const handleOption = (event, newOption) => {
    if (newOption !== null) {
      setOption(newOption);
    }
  };

  const handleClear = () => {
    setRate("");
    setOption("overall");
    setWeights({
      weight_lstm: 0,
      weight_bilstm: 0,
      weight_arima: 0,
      weight_sarima: 0,
      weight_iter: 0,
    });
  };
  const getCriticalLevelDescription = (criticalLevel) => {
    switch (criticalLevel) {
      case 5:
        return "Very Critical";
      case 4:
        return "High Critical";
      case 3:
        return "Moderate Critical";
      case 2:
        return "Low Critical";
      case 1:
        return "Very Low Critical";
      default:
        return "Unknown Critical Level";
    }
  };

  const handleSort = (key) => {
    const newDirection = sortConfig[key].direction === "asc" ? "desc" : "asc";
    setSortConfig({
      ...sortConfig,
      [key]: { direction: newDirection },
    });
  };

  const sortedDatalogs = [...datalogs].sort((a, b) => {
    const key = Object.keys(sortConfig).find(
      (k) => sortConfig[k].direction !== "asc"
    );
    if (!key) return 0;
    const direction = sortConfig[key].direction === "asc" ? 1 : -1;
    if (a[key] < b[key]) return -1 * direction;
    if (a[key] > b[key]) return 1 * direction;
    return 0;
  });

  const sortedImDatalogs = [...imdatalogs].sort((a, b) => {
    const key = Object.keys(sortConfig).find(
      (k) => sortConfig[k].direction !== "asc"
    );
    if (!key) return 0;
    const direction = sortConfig[key].direction === "asc" ? 1 : -1;
    if (a[key] < b[key]) return -1 * direction;
    if (a[key] > b[key]) return 1 * direction;
    return 0;
  });

  const downloadAsCSV = () => {
    const csv = Papa.unparse(datalogs);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "datalogs.csv");
  };

  const imdownloadAsCSV = () => {
    const csv = Papa.unparse(imdatalogs);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "datalogs.csv");
  };

  const downloadAsPDF = () => {
    const doc = new jsPDF();
    const tableData = datalogs.map((datalog) => [
      datalog.mTm,
      datalog.wtr,
    ]);

    doc.text("Datalogs", 14, 10);
    doc.autoTable({
      head: [["Measurement Time", "Water Level"]],
      body: tableData,
    });

    doc.save("datalogs.pdf");
  };

  const getDatalogs = (wellId) => {
    fetch(`https://warpo-dashboard.cse.buet.ac.bd/api/datalogs/${wellId}`)
      .then((res) => res.json())
      .then((datalogs) => {
        setDatalogs(datalogs);
        // console.log(datalogs);
      })
      .catch((err) => console.error(err));
  };
    useEffect(() => {
    if (selectedMarker) {
      getDatalogs(selectedMarker.wellId);
    }
  }, [selectedMarker]); // Fetch datalogs when selectedMarker changes

  const getImDatalogs = async (wellId) => {
    fetch(`https://warpo-dashboard.cse.buet.ac.bd/api/imdatalogs_last/${wellId}`)
      .then((res) => res.json())
      .then((newImdatalogs) => {
        setimDatalogs(newImdatalogs);
        console.log(newImdatalogs);
        return newImdatalogs;
      })
      .catch((err) => console.error(err));
  };

  const getFcDatalogs = async (wellId) => {
    fetch(`https://warpo-dashboard.cse.buet.ac.bd/api/imdatalogs_last/${wellId}`)
      .then((res) => res.json())
      .then((newImdatalogs) => {
        setimDatalogs(newImdatalogs);
        console.log(newImdatalogs);
        return newImdatalogs;
      })
      .catch((err) => console.error(err));
  };

  // const getImDatalogs = async (wellId) => {
  //   try {
  //     const res = await fetch(`https://warpo-dashboard.cse.buet.ac.bd/api/imdatalogs/${wellId}`);

  //     if (!res.ok) {
  //       throw new Error(`HTTP error! Status: ${res.status}`);
  //     }

  //     const data = await res.json();

  //     if (!Array.isArray(data)) {
  //       console.error("Error: Expected an array but received:", data);
  //       setimDatalogs([]); // Ensure `imdatalogs` is always an array
  //       return [];
  //     }

  //     setimDatalogs(data);
  //     console.log("Fetched imputed datalogs:", data);
  //     return data;
  //   } catch (error) {
  //     console.error("Error fetching imputed datalogs:", error);
  //     setimDatalogs([]); // Ensure `imdatalogs` is reset to an empty array on failure
  //     return [];
  //   }
  // };

  const handleDownload = () => {
    const chartElement = document.querySelector(".chart-container"); // Ensure correct selection
    if (!chartElement) {
      console.error("Chart element not found!");
      return;
    }

    setTimeout(() => {
      html2canvas(chartElement, { scale: 2, useCORS: true })
        .then((canvas) => {
          if (canvas) {
            canvas.toBlob((blob) => {
              if (blob) {
                saveAs(blob, "chart.png"); // Save as PNG (JPEG may cause quality loss)
              } else {
                console.error("Blob creation failed. Using DataURL instead.");
                const dataUrl = canvas.toDataURL("image/png");
                const link = document.createElement("a");
                link.href = dataUrl;
                link.download = "chart.png";
                link.click();
              }
            });
          } else {
            console.error("Canvas creation failed.");
          }
        })
        .catch((err) => console.error("html2canvas error:", err));
    }, 500); // Ensure the chart is fully rendered
  };

  const handleDoImputation = async (retryCount = 0, maxRetries = 5) => {
    if (selectedMarker) {
      setIsLoading(true); // Set loading state to true

      const url =
        weights.weight_lstm === 0 &&
        weights.weight_bilstm === 0 &&
        weights.weight_arima === 0 &&
        weights.weight_sarima === 0 &&
        weights.weight_iter === 0
          ? `https://warpo-dashboard.cse.buet.ac.bd/api/send-datalogs/${selectedMarker.wellId}/${Rate}/${option}`
          : `https://warpo-dashboard.cse.buet.ac.bd/api/send-datalogs/${selectedMarker.wellId}/${Rate}/${option}/${weights.weight_lstm}/${weights.weight_bilstm}/${weights.weight_arima}/${weights.weight_sarima}/${weights.weight_iter}`;

      try {
        const res = await fetch(url, { method: "POST" });
        if (!res.ok)
          throw new Error(`Request failed with status ${res.status}`);

        const imputedData = await res.json();
        console.log("Received imputed datalogs:", imputedData);

        // Fetch updated imputed datalogs
        const updatedData = await getImDatalogs(selectedMarker.wellId);
        // setimDatalogs(updatedData); // Ensure state is updated properly

        setIsImModalOpen(true); // Open modal only if successful
      } catch (err) {
        console.error(err);
        if (retryCount < maxRetries) {
          console.warn(`Retrying... Attempt ${retryCount + 1}`);
          await handleDoImputation(retryCount + 1, maxRetries); // Ensure retries are awaited
        } else {
          console.error("Max retries reached. Aborting.");
        }
      } finally {
        setIsLoading(false); // Reset loading state once imputation is completed
      }
    }
  };

  // const handleAnomalyCorrection = async (retryCount = 0, maxRetries = 3) => {
  //   if (selectedMarker) {
  //     setIsLoading(true); // Set loading state to true

  //     const url = https://warpo-dashboard.cse.buet.ac.bd/api/send-datalogs/${selectedMarker.wellId}/${AnRate};

  //     fetch(url, {
  //       method: "POST",
  //     })
  //       .then((res) => {
  //         if (!res.ok) {
  //           throw new Error(Request failed with status ${res.status});
  //         }
  //         return res.json();
  //       })
  //       .then((imdatalogs) => {
  //         console.log(imdatalogs);
  //         getImDatalogs(selectedMarker.wellId);
  //         // setimDatalogs(updatedData); // Ensure state is updated properly

  //         setIsImModalOpen(true); // Open modal only if successful
  //         // setIsAnModalOpen(true);
  //       })
  //       .catch((err) => {
  //         console.error(Attempt ${retryCount + 1} failed:, err.message);
  //         if (retryCount < maxRetries) {
  //           handleAnomalyCorrection(retryCount + 1, maxRetries); // Retry the request
  //         } else {
  //           console.error(
  //             "Max retries reached. Unable to send anomaly correction data."
  //           );
  //           // Optional: Display an error message to the user
  //         }
  //       })
  //       .finally(() => {
  //         if (retryCount === 0) {
  //           getImDatalogs(selectedMarker.wellId);
  //           setIsLoading(false); // Set loading state to false after all attempts
  //         }
  //       });
  //   }
  // };

  const handleAnomalyCorrection = async (retryCount = 0, maxRetries = 3) => {
    if (selectedMarker) {
      setIsLoading(true); // Set loading state to true

      const url = `https://warpo-dashboard.cse.buet.ac.bd/api/send-datalogs/${selectedMarker.wellId}/${AnRate}`;

      try {
        const res = await fetch(url, { method: "POST" });
        if (!res.ok)
          throw new Error(`Request failed with status ${res.status}`);

        // const newimDatalogs = await res.json();
        // console.log("Received anomaly correction datalogs:", newimDatalogs);

        // Fetch updated datalogs
        const updatedData = await getImDatalogs(selectedMarker.wellId);

        setIsAnModalOpen(true); // Open modal only if successful
      } catch (err) {
        console.error(`Attempt ${retryCount + 1} failed:`, err.message);
        if (retryCount < maxRetries) {
          console.warn(`Retrying... Attempt ${retryCount + 1}`);
          await handleAnomalyCorrection(retryCount + 1, maxRetries); // Ensure retries are awaited
        } else {
          console.error("Max retries reached. Aborting anomaly correction.");
        }
      } finally {
        setIsLoading(false); // Reset loading state once completed
      }
    }
  };

  const handleBack = () => {
    setSelectedColor(null);
  };
  const [isLoading, setIsLoading] = useState(false);

  // Render loading indicator
  if (isLoading) {
    return (
      <Modal
        open={isLoading}
        onClose={() => setIsLoading(false)}
        className="loading-modal"
      >
        <div className="loading-content">
          <CircularProgress color="primary" />
          <Typography
            variant="h6"
            style={{ marginTop: "20px", color: "#333333" }}
          >
            Working, Please Wait ...
          </Typography>
          {/* <div className="progress-bar">
            <div className="progress" style={{ width: `${progress}%` }}></div>
          </div> */}
          {/* <Typography
            variant="body1"
            style={{ marginTop: "10px", color: "#333333" }}
          >
            {progress}%
          </Typography> */}
        </div>
      </Modal>
    );
  }

  const handleImageClick = () => setImageZoomed(!imageZoomed);
  const handleCloseZoom = () => setImageZoomed(false);
  const handleShowDatalog = () => {
    setIsModalOpen(true);
    console.log("Selected Marker:", selectedMarker);
    resetZoomDatalogs();
  };

  const handleShowRegions = (color) => {
    setSelectedColor(color);
  };
  const getRegionsByColor = (color) => {
    return regions.filter(
      (region) => getStrokeColor(region.critical_level) === color
    );
  };

  const handleShowImDatalog = () => {
    setIsLoading(true);
    setProgress(0);
    const duration = 5000; // Total duration in milliseconds (5 seconds)
    const intervalTime = 50; // Interval time in milliseconds
    const increment = 100 / (duration / intervalTime); // Calculate increment value

    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 100) {
          clearInterval(interval);
          setTimeout(() => {
            getImDatalogs(selectedMarker.wellId);
            setIsImModalOpen(true);
            setIsLoading(false);
          }, 2000); // Keep the screen for an additional 1 second after progress completes
          return 100;
        }
        return prevProgress + increment;
      });
    }, intervalTime);
  };

  const handleShowFcDatalog = () => {
    setIsLoading(true);
    setProgress(0);
    const duration = 5000; // Total duration in milliseconds (5 seconds)
    const intervalTime = 50; // Interval time in milliseconds
    const increment = 100 / (duration / intervalTime); // Calculate increment value

    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 100) {
          clearInterval(interval);
          setTimeout(() => {
            getFcDatalogs(selectedMarker.wellId);
            setIsFcModalOpen(true);
            setIsLoading(false);
          }, 2000); // Keep the screen for an additional 1 second after progress completes
          return 100;
        }
        return prevProgress + increment;
      });
    }, intervalTime);
  };

  const handleShowAnDatalog = () => {
    setIsLoading(true);
    setProgress(0);
    const duration = 5000; // Total duration in milliseconds (5 seconds)
    const intervalTime = 50; // Interval time in milliseconds
    const increment = 100 / (duration / intervalTime); // Calculate increment value

    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 100) {
          clearInterval(interval);
          setTimeout(() => {
            getImDatalogs(selectedMarker.wellId);
            setIsAnModalOpen(true);
            setIsLoading(false);
          }, 2000); // Keep the screen for an additional 1 second after progress completes
          return 100;
        }
        return prevProgress + increment;
      });
    }, intervalTime);
  };

  const handleCloseAnModal = () => setIsAnModalOpen(false);
  const handleCloseImModal = () => setIsImModalOpen(false);
  const handleCloseFcModal = () => setIsFcModalOpen(false);
  const handleCloseMultiColImModal = () => setIsMultiColImModalOpen(false)
  const handleCloseMultiColAnModal = () => setIsMultiColAnModalOpen(false)
  const handleCloseMultiColFcModal = () => setIsMultiColFcModalOpen(false)
  const handleCloseModal = () => setIsModalOpen(false);

  return (
    <div>
      <div className="leftbar">
        <div className="leftbar-inner">
        <header className="leftbar-toolbar">
          <button
            type="button"
            className="leftbar-close-btn"
            onClick={handleClearLeftbar}
          >
            Close panel
          </button>
        </header>
        {regionClicked && (
          <div className="region-info">
            <button onClick={handleClearLeftbar}>Back</button>
            <h2>Region Information</h2>
            <p>
              Region ID: {regionClicked.regionId} <br />
              Critical Level: {regionClicked.critical_level} (
              {getCriticalLevelDescription(regionClicked.critical_level)})<br />
              Total Well in this region:{" "}
              {getWellMarkerCount(regionClicked.regionId)} <br />
            </p>
          </div>
        )}
        {selectedMarker ? (
          <div className="leftbar-content">
            <section className="leftbar-well-card" aria-labelledby="leftbar-well-heading">
              <div className="leftbar-well-card__head">
                <FontAwesomeIcon
                  icon={faMapMarker}
                  className="leftbar-well-card__icon"
                  aria-hidden
                />
                <div>
                  <h1 id="leftbar-well-heading" className="leftbar-well-card__title">
                    {selectedMarker.wellId}
                  </h1>
                  <p className="leftbar-well-card__subtitle">Selected well</p>
                </div>
              </div>
              <dl className="leftbar-meta">
                <div className="leftbar-meta__row">
                  <dt>Division</dt>
                  <dd>{selectedMarker.division ?? "—"}</dd>
                </div>
                <div className="leftbar-meta__row">
                  <dt>District</dt>
                  <dd>{selectedMarker.district ?? "—"}</dd>
                </div>
                <div className="leftbar-meta__row">
                  <dt>Upazila</dt>
                  <dd>{selectedMarker.upazilla ?? "—"}</dd>
                </div>
                <div className="leftbar-meta__row">
                  <dt>Union</dt>
                  <dd>{selectedMarker.union_ ?? "—"}</dd>
                </div>
                <div className="leftbar-meta__row">
                  <dt>Latitude</dt>
                  <dd>{selectedMarker.locations.lat ?? "—"}</dd>
                </div>
                <div className="leftbar-meta__row">
                  <dt>Longitude</dt>
                  <dd>{selectedMarker.locations.lng ?? "—"}</dd>
                </div>
              </dl>
            </section>

            <section className="leftbar-actions" aria-label="Well data tools">
              <h2 className="leftbar-actions__label">Data &amp; analysis</h2>
              <div className="leftbar-actions__grid">
                <button
                  type="button"
                  className="leftbar-btn leftbar-btn--raw"
                  onClick={handleShowDatalog}
                >
                  Raw datalog
                </button>
                <button
                  type="button"
                  className="leftbar-btn leftbar-btn--purified"
                  onClick={handleShowPurifiedDatalog}
                >
                  Purified datalog
                </button>
                {role === "admin" && (
                  <>
                    <button
                      type="button"
                      className="leftbar-btn leftbar-btn--impute"
                      onClick={handleShowImDatalog}
                    >
                      Imputation
                    </button>
                    <button
                      type="button"
                      className="leftbar-btn leftbar-btn--anomaly"
                      onClick={handleShowAnDatalog}
                    >
                      Anomaly correction
                    </button>
                  </>
                )}
                <button
                  type="button"
                  className="leftbar-btn leftbar-btn--forecast"
                  onClick={handleShowFcDatalog}
                >
                  Forecasting
                </button>
              </div>
            </section>



            </div>): (
          <div></div>
        )}
        {showRegionInfo && (
          <div className="region">
            {!selectedColor ? (
              <>
                <handleClearLeftbar />
                <h1 className="region-header">
                  <span className="highlight">Region colors</span>
                </h1>
                <ul>
                  <li>
                    <span
                      className="color-box"
                      style={{ backgroundColor: "red" }}
                    ></span>{" "}
                    Critical level highest
                    <button onClick={() => handleShowRegions("red")}>
                      Show Regions
                    </button>
                  </li>
                  <li>
                    <span
                      className="color-box"
                      style={{ backgroundColor: "orange" }}
                    ></span>{" "}
                    Critical level moderately higher
                    <button onClick={() => handleShowRegions("orange")}>
                      Show Regions
                    </button>
                  </li>
                  <li>
                    <span
                      className="color-box"
                      style={{ backgroundColor: "yellow" }}
                    ></span>{" "}
                    Critical level average
                    <button onClick={() => handleShowRegions("yellow")}>
                      Show Regions
                    </button>
                  </li>
                  <li>
                    <span
                      className="color-box"
                      style={{ backgroundColor: "lime" }}
                    ></span>{" "}
                    Critical level moderately lower
                    <button onClick={() => handleShowRegions("lime")}>
                      Show Regions
                    </button>
                  </li>
                  <li>
                    <span
                      className="color-box"
                      style={{ backgroundColor: "green" }}
                    ></span>{" "}
                    Critical level lowest
                    <button onClick={() => handleShowRegions("green")}>
                      Show Regions
                    </button>
                  </li>
                </ul>
              </>
            ) : (
              <div className="region-list-container">
                <button onClick={handleBack}>Back</button>
                <h2>Regions with {selectedColor} color:</h2>
                <ul className="region-list">
                  {getRegionsByColor(selectedColor).map((region) => (
                    <li key={region.regionId}>
                      {region.regionId}:- Wells count:{" "}
                      {getWellMarkerCount(region.regionId)}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )}
        </div>
      </div>

      {/* ── Modals rendered OUTSIDE .leftbar so they escape its stacking context ── */}
      {isAnModalOpen && (
        <Anomalylog
          selectedMarker={selectedMarker}
          imdatalogs={imdatalogs}
          setimDatalogs={setimDatalogs}
          startIndexDatalogs={startIndexDatalogs}
          endIndexDatalogs={endIndexDatalogs}
          setIsLoading={setIsLoading}
          isLoading={isLoading}
          CustomLegend={CustomLegend}
          handleCloseAnModal={handleCloseAnModal}
          handleZoomInImDatalogs={handleZoomInImDatalogs}
          sortConfig={sortConfig}
          setSortConfig={setSortConfig}
          getImDatalogs={getImDatalogs}
          handleZoomOutImDatalogs={handleZoomOutImDatalogs}
          resetZoomImDatalogs={resetZoomImDatalogs}
          zoomLevelImDatalogs={zoomLevelImDatalogs}
          handleZoomImDatalogs={handleZoomImDatalogs}
          handleDataLimitChangeImDatalogs={handleDataLimitChangeImDatalogs}
          visibleDataImDatalogs={visibleDataImDatalogs}
          filteredDataImDatalogs={filteredDataImDatalogs}
          sortedImDatalogs={sortedImDatalogs}
          dataLimitImDatalogs={dataLimitImDatalogs}
          handleDownload={handleDownload}
          setIsAnModalOpen={setIsAnModalOpen}
          setIsMultiColAnModalOpen={setIsMultiColAnModalOpen}
          formatDate={formatDate}
        />
      )}

      {isImModalOpen && (
        <Imputlog
          selectedMarker={selectedMarker}
          CustomLegend={CustomLegend}
          setIsImModalOpen={setIsImModalOpen}
          setIsMultiColImModalOpen={setIsMultiColImModalOpen}
          HelpModal={HelpModal}
          imdatalogs={imdatalogs}
          setimDatalogs={setimDatalogs}
          formatDate={formatDate}
          helpOpen={helpOpen}
          setHelpOpen={setHelpOpen}
          handleCloseImModal={handleCloseImModal}
        />
      )}

      {IsMultiColImModalOpen && (
        <MultiColImputeLog
          selectedMarker={selectedMarker}
          setIsMultiColImModalOpen={setIsMultiColImModalOpen}
          getImDatalogs={getImDatalogs}
          multiColImDatalogs={multiColImDatalogs}
          setMultiColImDatalogs={setMultiColImDatalogs}
          handleCloseMultiColImModal={handleCloseMultiColImModal}
          helpOpen={helpOpen}
          setHelpOpen={setHelpOpen}
          formatDate={formatDate}
          HelpModal={HelpModal}
        />
      )}

      {IsMultiColAnModalOpen && (
        <MultiColAnomalyLog
          selectedMarker={selectedMarker}
          formatDate={formatDate}
          imdatalogs={imdatalogs}
          setimDatalogs={setimDatalogs}
          getImDatalogs={getImDatalogs}
          setIsMultiColAnModalOpen={setIsMultiColAnModalOpen}
          handleCloseMultiColAnModal={handleCloseMultiColAnModal}
        />
      )}

      {isFcModalOpen && (
        <Forecastlog
          selectedMarker={selectedMarker}
          CustomLegend={CustomLegend}
          setIsFcModalOpen={setIsFcModalOpen}
          setIsMultiColFcModalOpen={setIsMultiColFcModalOpen}
          HelpModal={HelpModal}
          datalogs={datalogs}
          imdatalogs={imdatalogs}
          setimDatalogs={setimDatalogs}
          formatDate={formatDate}
          helpOpen={helpOpen}
          setHelpOpen={setHelpOpen}
          handleCloseFcModal={handleCloseFcModal}
        />
      )}

      {isMultiColFcModalOpen && (
        <MultiColForecastLog
          selectedMarker={selectedMarker}
          CustomLegend={CustomLegend}
          setIsMultiColFcModalOpen={setIsMultiColFcModalOpen}
          HelpModal={HelpModal}
          datalogs={datalogs}
          imdatalogs={imdatalogs}
          setimDatalogs={setimDatalogs}
          formatDate={formatDate}
          helpOpen={helpOpen}
          setHelpOpen={setHelpOpen}
          handleCloseMultiColFcModal={handleCloseMultiColFcModal}
        />
      )}

      {isModalOpen && (
        <Datalog
          selectedMarker={selectedMarker}
          selectedMetric={selectedMetric}
          downloadAsCSV={downloadAsCSV}
          downloadAsPDF={downloadAsPDF}
          handleCloseModal={handleCloseModal}
          handleZoomInDatalogs={handleZoomInDatalogs}
          handleZoomOutDatalogs={handleZoomOutDatalogs}
          resetZoomDatalogs={resetZoomDatalogs}
          handleDownload={handleDownload}
          formatDate={formatDate}
          setHelpOpen={setHelpOpen}
          helpOpen={helpOpen}
          handleCloseImModal={handleCloseImModal}
          dataLimitDatalogs={dataLimitDatalogs}
          filteredDataDatalogs={filteredDataDatalogs}
          visibleDataDatalogs={visibleDataDatalogs}
          datalogs={datalogs}
          sortConfig={sortConfig}
          handleDataLimitChangeDatalogs={handleDataLimitChangeDatalogs}
          handleSort={handleSort}
          CustomLegend={CustomLegend}
        />
      )}

      {ispurifiedModalOpen && (
        <Purifiedlog
          selectedMarker={selectedMarker}
          CustomLegend={CustomLegend}
          setispurifiedModalOpen={setispurifiedModalOpen}
          HelpModal={HelpModal}
          purifiedDatalogs={purifiedDatalogs}
          setpurifiedDatalogs={setPurifiedDatalogs}
          formatDate={formatDate}
          helpOpen={helpOpen}
          setHelpOpen={setHelpOpen}
          handleClosepurifiedModal={handleClosepurifiedModal}
        />
      )}
    </div>
  );
};

export default Leftbar;
